<template>
  <div id="app">
    <router-view/>
    <watermark/>
  </div>
</template>

<script>
import Watermark from '@/components/Watermark.vue'

export default {
  name: 'App',
  components: {
    Watermark
  },
  created() {
    this.handleWebSocketAuthFailed = (event) => {
      this.$store.dispatch('logout');
      this.$message.warning(event?.detail?.reason || '登录已过期，请重新登录');
      if (this.$route && this.$route.path !== '/home' && this.$route.path !== '/') {
        this.$router.push('/home').catch(() => {});
      }
    };
    window.addEventListener('websocket-auth-failed', this.handleWebSocketAuthFailed);
  },
  beforeDestroy() {
    window.removeEventListener('websocket-auth-failed', this.handleWebSocketAuthFailed);
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

    height: 100%;
    width: 100%;
}

.flex {
    display: flex;
}

.block{
    height: 10px;
}


/* 滚动条样式设置 */

::-webkit-scrollbar {
    width: 8px;
    background: transparent;
    height: 8px;
}

::-webkit-scrollbar-thumb {
    background: #ddd;
    width: 8px;
    border-radius: 8px;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
}

/* 移动端 Element UI MessageBox / Confirm 弹框全局适配 */
@media (max-width: 768px) {
  .el-message-box {
    width: 86vw !important;
    max-width: 330px !important;
    border-radius: 14px !important;
    padding: 16px 14px 14px !important;
    box-sizing: border-box !important;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;
    border: none !important;

    .el-message-box__header {
      padding: 0 0 8px 0 !important;

      .el-message-box__title {
        font-size: 16px !important;
        font-weight: 600 !important;
        color: #1f2d3d !important;
      }

      .el-message-box__headerbtn {
        top: 14px !important;
        right: 14px !important;
      }
    }

    .el-message-box__content {
      padding: 6px 0 16px 0 !important;
      font-size: 14px !important;
      line-height: 1.5 !important;
      color: #606266 !important;
    }

    .el-message-box__btns {
      display: flex !important;
      flex-direction: row !important;
      gap: 10px !important;
      padding: 0 !important;

      button {
        flex: 1 !important;
        height: 38px !important;
        border-radius: 8px !important;
        font-size: 14px !important;
        margin: 0 !important;
        font-weight: 500 !important;
      }
    }
  }

  /* 移动端 Toast / Message 宽度自适应 */
  .el-message {
    min-width: unset !important;
    width: auto !important;
    max-width: 90vw !important;
    padding: 10px 16px !important;
    border-radius: 8px !important;
    top: 20px !important;
  }
}

/* 修复 Element UI Loading 动画因 Tailwind CSS 基础样式 (svg display: block) 导致的居中失效问题 */
.el-loading-spinner {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;

  .circular {
    display: inline-block !important;
    margin: 0 auto !important;
  }

  .el-loading-text {
    text-align: center !important;
    width: 100% !important;
  }
}

/* 兼容 Vant loading 组件居中表现 */
.van-loading {
  text-align: center;

  .van-loading__spinner {
    margin: 0 auto;
  }
}

</style>
